import { del, get, patch, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPISites {
    //This method returns all of an organization's sites.
    getAllSites() {
        return operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/sites",
        }));
    }
    //This method returns a single site by its unique ID.
    getSpecificSite(siteID) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}`,
        })));
    }
    //This method creates a new site.
    createNewSite(params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/sites",
            options: {
                body: params,
            },
        })));
    }
    //This method modifies the name or perimeter coordinates of a site.
    modifyExistingSite(siteID, params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}`,
            options: {
                body: params,
            },
        })));
    }
    //This method deletes an existing site.
    deleteExistingSite(siteID) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/sites/${siteID}`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-sites.js.map